import BaseBean from "@/utils/BaseBean";

export interface IZyfwzListDataObj {
    utilInst:ZyfwzListUtil
    refMap:Map<string,any>
    importGuidParams:any
    pageListRef:any
    pageList: any
}

export default class ZyfwzListUtil extends BaseBean{
    public dataObj:IZyfwzListDataObj

    constructor(proxy:any,dataObj:IZyfwzListDataObj) {
        super(proxy);
        this.dataObj=dataObj;
    }
}